import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../api";

const DynamicFromOurStudents = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [sliderSettings, setSliderSettings] = useState({
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch testimonials
        const testimonialsRes = await api.get(
          `${process.env.REACT_APP_API_URL}/api/student-testimonials`
        );
        const testimonialsData = testimonialsRes.data;

        // Fetch slider settings
        const settingsRes = await api.get(
          `${process.env.REACT_APP_API_URL}/api/slider-settings/student_testimonials`
        );
        const settingsData = settingsRes.data;

        // Transform settings to match react-slick's expected format
        const transformedSettings = {
          dots: settingsData.dots || false,
          infinite: settingsData.infinite || true,
          speed: settingsData.speed || 500,
          autoplay: settingsData.autoplay || false,
          autoplaySpeed: settingsData.autoplay_speed || 5000,
          slidesToShow: settingsData.slides_to_show || 3,
          slidesToScroll: settingsData.slides_to_scroll || 1,
          responsive: settingsData.responsive
            ? settingsData.responsive.map((item) => ({
                breakpoint: item.breakpoint,
                settings: {
                  slidesToShow: item.settings.slidesToShow,
                  slidesToScroll: item.settings.slidesToScroll || 1,
                },
              }))
            : [],
        };

        setSliderSettings(transformedSettings);

        // Handle testimonials data
        if (testimonialsData.length >= 3) {
          setTestimonials(testimonialsData);
        } else {
          const fallback = [...testimonialsData];
          while (fallback.length < 3) {
            fallback.push({
              name: "Sample Student",
              course: "Sample Course",
              image_path: "/placeholder.jpg",
              video_link: "",
            });
          }
          setTestimonials(fallback);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <section className="testimonial-style1-area">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="testimonial-style1__title">
              <div className="sec-title">
                <h2>Real Stories, Real Impact</h2>
              </div>
              {/* <div className="btns-box">
                                  <a className="btn-one" href="#">
                                      <span className="txt">More Videos</span>
                                  </a>
                              </div> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="testimonial-style1-content">
              <div className="from-our-students-section">
                {testimonials.length >= 3 ? (
                  <Slider {...sliderSettings}>
                    {testimonials.map((item, index) => (
                      <div key={index} className="single-testimonial-style1">
                        <div className="border-box"></div>
                        <div
                          className="position-relative yt_videos_wrapper"
                          style={{ height: "400px" }}
                        >
                          <iframe
                            src={item.video_link}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            style={{ width: "100%", height: "100%" }}
                          ></iframe>
                        </div>
                        <div className="client-name">
                          <h3>{item.name}</h3>
                          <span>{item.course}</span>
                        </div>
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DynamicFromOurStudents;
